import { render, staticRenderFns } from "./calcPractise2.vue?vue&type=template&id=2e8b321d&scoped=true&"
import script from "./calcPractise2.vue?vue&type=script&lang=js&"
export * from "./calcPractise2.vue?vue&type=script&lang=js&"
import style0 from "./calcPractise2.vue?vue&type=style&index=0&id=2e8b321d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b321d",
  null
  
)

export default component.exports